import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent5"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code5-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code5-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Headings Badges", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab5",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview5-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview5-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview5-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code5-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code5-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code5-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview5-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview5-tab",
          tabindex: "0"
        }, [
          _createElementVNode("h1", null, [
            _createTextVNode("Example heading "),
            _createElementVNode("span", { class: "badge bg-primary" }, "New")
          ]),
          _createElementVNode("h2", null, [
            _createTextVNode("Example heading "),
            _createElementVNode("span", { class: "badge bg-secondary" }, "New")
          ]),
          _createElementVNode("h3", null, [
            _createTextVNode("Example heading "),
            _createElementVNode("span", { class: "badge bg-success" }, "New")
          ]),
          _createElementVNode("h4", null, [
            _createTextVNode("Example heading "),
            _createElementVNode("span", { class: "badge bg-warning" }, "New")
          ]),
          _createElementVNode("h5", null, [
            _createTextVNode("Example heading "),
            _createElementVNode("span", { class: "badge bg-danger" }, "New")
          ]),
          _createElementVNode("h6", null, [
            _createTextVNode("Example heading "),
            _createElementVNode("span", { class: "badge bg-info" }, "New")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "codeCopy"
            }, "\n<h1>Example heading <span class=\"badge bg-primary\">New</span></h1>\n<h2>Example heading <span class=\"badge bg-secondary\">New</span></h2>\n<h3>Example heading <span class=\"badge bg-success\">New</span></h3>\n<h4>Example heading <span class=\"badge bg-warning\">New</span></h4>\n<h5>Example heading <span class=\"badge bg-danger\">New</span></h5>\n<h6>Example heading <span class=\"badge bg-info\">New</span></h6>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}